import { RootState, useAppSelector } from '../../../store';
import { Button } from '../../Utility/Button';

const MessageEditor = ({
    originalContent,
    editMessageHandler,
    identifier,
    setEditableMessage,
    setEditedChatMessage,
}: any) => {
    const i18n = useAppSelector((state: RootState) => state.i18n.i18n);
    return (
        <>
            <textarea
                id="editedContent"
                className="w-full h-[200px] border-2 border-gray-300 rounded-md p-2 mb-2 text-layout-textcolor bg-input-backgroundColor focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary"
                defaultValue={originalContent}
                onChange={(e) => setEditedChatMessage(e.target.value)}
            />
            <Button
                onClick={() => {
                    editMessageHandler(identifier);
                    setEditableMessage(() => '');
                }}
                className="mr-2"
            >
                {i18n.translate({ id: 'save' })}
            </Button>
            <Button variant="secondary" onClick={() => setEditableMessage(() => '')}>
                {i18n.translate({ id: 'abort' })}
            </Button>
        </>
    );
};

export default MessageEditor;
